import React from 'react';
import {Link, useLocation, useParams} from 'react-router-dom';
import {useTranslation} from '../../../hook/useTranslation';
import Contact from '../../contact/Contact';
import {ausbildung, pflegeentwicklung, management} from './../../../icons/icons';
import './Abstract.scss';

export default function LayoutAbstract() {
    const location = useLocation();
    const {translationPath} = useParams<'translationPath'>();
    const i18n = useTranslation();

    return (
        <div className="career-model__abstract">
            <h1 className="career-model__abstract--title">{i18n.translate(`show.items.${translationPath}.title`)}</h1>
            <p className="career-model__abstract--desc">{i18n.translate(`show.items.${translationPath}.description`)}</p>
            <div className="career-model__abstract--links">
                <div className="career-model__abstract--link-1">
                    <div className="career-model__abstract--icon-1" dangerouslySetInnerHTML={{__html: ausbildung}}></div>
                    <Link to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.ausbildung.link`)}
                          state={{backgroundLocation: location}}>
                        {i18n.translate(`show.items.${translationPath}.items.ausbildung.title`)}
                    </Link>
                </div>
                <div className="career-model__abstract--link-2">
                    <div className="career-model__abstract--icon-2" dangerouslySetInnerHTML={{__html: pflegeentwicklung}}></div>
                    <Link to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.pflegeentwicklung.link`)}
                          state={{backgroundLocation: location}}>
                        {i18n.translate(`show.items.${translationPath}.items.pflegeentwicklung.title`)}
                    </Link>
                </div>
                <div className="career-model__abstract--link-3">
                    <div className="career-model__abstract--icon-3" dangerouslySetInnerHTML={{__html: management}}></div>
                    <Link to={i18n.translate(`show.back_link`) + i18n.translate(`show.items.${translationPath}.items.management.link`)}
                          state={{backgroundLocation: location}}>
                        {i18n.translate(`show.items.${translationPath}.items.management.title`)}
                    </Link>
                </div>
                <div className="career-model__abstract--center-links">
                    <h2 className="career-model__abstract--items-title">{i18n.translate(`show.items.${translationPath}.items_title`)}</h2>
                    <p className="career-model__abstract--items-desc" dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items_description`)}}></p>
                </div>
            </div>
            <div className="career-model__abstract--spacer"></div>
            <div className="career-model__abstract--center-links-mobile">
                <h2 className="career-model__abstract--items-title">{i18n.translate(`show.items.${translationPath}.items_title`)}</h2>
                <p className="career-model__abstract--items-desc" dangerouslySetInnerHTML={{__html: i18n.translate(`show.items.${translationPath}.items_description`)}}></p>
            </div>
            {
                i18n.keyExists(`show.items.${translationPath}.override.contact.person.name`) ? (
                    <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                             person={{
                                 email: i18n.translate(`show.items.${translationPath}.override.contact.person.email`),
                                 emailLabel: i18n.translate(`show.items.${translationPath}.override.contact.person.email-label`),
                                 image: i18n.translate(`show.items.${translationPath}.override.contact.person.image`),
                                 name: i18n.translate(`show.items.${translationPath}.override.contact.person.name`),
                                 phone: i18n.translate(`show.items.${translationPath}.override.contact.person.phone`),
                                 title: i18n.translate(`show.items.${translationPath}.override.contact.person.title`)
                             }}/>
                ) : (
                    i18n.keyExists(`show.items.${translationPath}.override.contact.text`) ? (
                        <Contact title={i18n.translate(`show.items.${translationPath}.override.contact.title`)}
                                 text={i18n.translate(`show.items.${translationPath}.override.contact.text`)}/>
                    ) : (
                        <Contact title={i18n.translate('show.contact.title')}
                                 person={{
                                     email: i18n.translate('show.contact.person.email'),
                                     emailLabel: i18n.translate(`show.contact.person.email-label`),
                                     image: i18n.translate('show.contact.person.image'),
                                     name: i18n.translate('show.contact.person.name'),
                                     phone: i18n.translate('show.contact.person.phone'),
                                     title: i18n.translate('show.contact.person.title')
                                 }}/>
                    )
                )}
        </div>
    );
};
